import { render, staticRenderFns } from "./ControleGaiola.vue?vue&type=template&id=0f8a927e&scoped=true"
import script from "./ControleGaiola.vue?vue&type=script&lang=js"
export * from "./ControleGaiola.vue?vue&type=script&lang=js"
import style0 from "./ControleGaiola.vue?vue&type=style&index=0&id=0f8a927e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a927e",
  null
  
)

export default component.exports